import { createAction } from '@reduxjs/toolkit';
import type { UpsellState } from './state';
import { CartItemActionType } from '../CartItem/action';

export enum UpsellActionType {
    REMOVE_UPSELL = 'REMOVE_UPSELL',
    SET_ALL_UPSELL_DATA = 'SET_ALL_UPSELL_DATA',
    SET_UPSELL_AMOUNT = 'SET_UPSELL_AMOUNT',
}

export type RemoveUpsellPayload = { id: number; parentCartItemId: number; parentProductId: number; productId: number };
export const removeUpsell = createAction<RemoveUpsellPayload>(UpsellActionType.REMOVE_UPSELL);

export const setAllUpsellData = createAction<UpsellState>(UpsellActionType.SET_ALL_UPSELL_DATA);

export type SetUpsellAmountPayload = { amount: number; id: number; parentCartItemId: string };
export const setUpsellAmount = createAction<SetUpsellAmountPayload>(UpsellActionType.SET_UPSELL_AMOUNT);

export type AddUpsellCartItemPayload = {
    amount?: number;
    parentCartItemId: number;
    productId: number;
    upsellGroupId: number;
};
export const addUpsellCartItem = createAction<AddUpsellCartItemPayload>(CartItemActionType.ADD_UPSELL_CART_ITEM);
